import React, { FC, useState } from 'react';
import Web3 from 'web3';
import { toast } from 'react-toastify';
import { useContract } from 'hooks';
import { Button } from 'components';
import { useWeb3React } from '@web3-react/core';
import styles from './styles.module.scss';
import { ReactComponent as Binance } from '../../../../assets/images/logo/binance.svg';
import { Image } from '../interface';

type Props = {
  idx: string,
  image: Image
  handleGetInfoNFT: () => void,
};

export const Buy: FC<Props> = ({ idx, image, handleGetInfoNFT }) => {
  const { contractDex } = useContract();
  const [isLoader, setLoader] = useState<boolean>(false);

  const { account } = useWeb3React();

  const handleBuy = async () => {
    try {
      setLoader(true);

      const estimateGas = await contractDex?.methods?.buyPunk(idx)
        .estimateGas({ from: account, value: image.offer?.min_value });

      await contractDex?.methods?.buyPunk(image.offer?.min_value, idx).call({ from: account, gas: estimateGas });
      setLoader(false);
      toast.success('Buy successful');
      handleGetInfoNFT();
    } catch (e) {
      console.log(e);
      setLoader(false);
      toast.error('Buy reject');
    }
  };

  return (
    <>
      <div className={styles.priceContainer}>
        <p className={styles.price}>
          {image.is_for_sale ? Web3.utils.fromWei(image?.offer?.min_value || '') : image.value}
        </p>
        <Binance className={styles.priceIcon} />
      </div>
      <Button
        loading={isLoader}
        className={styles.buyButton}
        onClick={handleBuy}
      >
        BUY
      </Button>
    </>
  );
};
